import findLastIndex from 'lodash-es/findLastIndex'

import { getPropsFromNode, nodeListToArray } from '../utils'
import Blockquote from '../../components/atom/Blockquote'
import { h } from '../parser/utils'

export const NAME = 'blockquote'

export const COMPONENTS = {
  Blockquote,
}

export function matches(node) {
  return node.nodeName?.toLowerCase() === 'blockquote'
}

export async function transform(node, next, ctx) {
  const nodes = nodeListToArray(node.childNodes)

  const citeIdx = findLastIndex(nodes, node => node.nodeName.toLowerCase() === 'cite')

  const children = await next(
    nodes.filter((node, idx) => idx !== citeIdx && node.nodeName.toLowerCase() !== 'br'),
    ctx,
  )

  const cite = nodes[citeIdx]?.textContent ?? undefined

  const props = getPropsFromNode(node)

  return h(
    Blockquote,
    {
      ...props,
      cite: cite ?? props.cite,
    },
    ...children
  )
}
